import { useGetAccount } from "apollo/hooks/queries";
import type { Account } from "core/types";
import { TEXT_DARK_PRIMARY } from "ds_legacy/materials/colors";
import { Caption } from "ds_legacy/materials/typography";
import { useMemo } from "react";
import { Link } from "react-router-dom";

function getAccountLabel(account: Account | undefined): string {
  if (account == null) return "";
  return [account.first_name, account.last_name].truthy().join(" ");
}

export function TranslationAuditAccountCaption({
  accountId,
  label,
}: {
  accountId: number | null | undefined;
  label: string;
}) {
  const id = accountId != null ? accountId : undefined;
  const [, account] = useGetAccount(id, {
    fetchPolicy: "cache-first",
  });

  const displayLabel = useMemo(() => getAccountLabel(account), [account]);

  if (id == null) {
    return null;
  }

  const to = `/acp/dashboard/account/${id}`;
  const linkText = displayLabel !== "" ? displayLabel : `#${id}`;

  return (
    <Caption>
      <b>{label}</b>&nbsp;
      <Link
        style={{ color: TEXT_DARK_PRIMARY, textDecoration: "underline" }}
        to={to}
      >
        {linkText}
      </Link>
      {displayLabel !== "" && <span style={{ opacity: 0.75 }}> ({id})</span>}
    </Caption>
  );
}
